import { setupSlider, SIMPLE_ARROW_SHAPE } from '../components/slider'

const SELECTORS = Selectors({
  slider: 'happening-slider'
})

const $sliders = document.querySelectorAll(SELECTORS.asClass('slider'))

const fn = {
  init: () => {
    if ($sliders.length) {
      fn.setupImageSliders()
    }
  },

  setupImageSliders: () => {
    $sliders.forEach($el => {
      const opts = {
        autoPlay: false,
        arrowShape: SIMPLE_ARROW_SHAPE,
        cellAlign: 'center'
      }

      $el.classList.add('slider--contain')

      setupSlider($el, opts)
    })
  }
}

export default {
  can: () => document.body.classList.contains('pagetype-newspage') || document.body.classList.contains('pagetype-eventspage'),
  run: fn.init
}
